import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-marine text-white space-y-14">
      <img
        src="/profil.jpg"
        alt="Behlül Kelez"
        className="w-80 h-80 rounded-full object-cover object-top border-4 border-gold shadow-2xl"
      />

      <div>
        <h1 className="text-5xl font-bold text-gold">Behlül Kelez</h1>
        <p className="text-3xl italic mt-3" style={{ color: '#737373' }}>M.Sc. Informationstechnik - B.Sc. Biomedizintechnik</p>
        <p className="text-base text-silver italic mt-2">„Daten verbinden Informationstechnik, Data Science, Medizin und Wirtschaft – für effiziente Systeme, kluge Entscheidungen und eine technologische Zukunft.“</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">
        {/* Profil */}
        <div className="bg-slateblue p-6 rounded-xl shadow-md w-64 border border-silver 
                        hover:border-gold hover:shadow-[0_0_25px_#e6c770] hover:scale-[1.02] 
                        transition-all duration-300 ease-in-out">
          <h2 className="font-bold text-xl mb-2 text-gold">👨🏻‍💻 Profil</h2>
          <p className="text-gray-200 text-sm mb-2">Mehr über mich und meinen beruflichen Hintergrund</p>
          <Link to="/profil" className="text-gold underline text-sm">→ Zu den persönlichen Daten</Link>
        </div>

        {/* Kenntnisse */}
        <div className="bg-slateblue p-6 rounded-xl shadow-md w-64 border border-silver 
                        hover:border-gold hover:shadow-[0_0_25px_#e6c770] hover:scale-[1.02] 
                        transition-all duration-300 ease-in-out">
          <h2 className="font-bold text-xl mb-2 text-gold">🧠 Kenntnisse</h2>
          <p className="text-gray-200 text-sm mb-2">Meine technischen Fähigkeiten im Überblick</p>
          <Link to="/kenntnisse" className="text-gold underline text-sm">→ Zu den Kenntnissen</Link>
        </div>

        {/* Projekte */}
        <div className="bg-slateblue p-6 rounded-xl shadow-md w-64 border border-silver 
                        hover:border-gold hover:shadow-[0_0_25px_#e6c770] hover:scale-[1.02] 
                        transition-all duration-300 ease-in-out">
          <h2 className="font-bold text-xl mb-2 text-gold">📚 Projekte</h2>
          <p className="text-gray-200 text-sm mb-2">Signale, Daten und medizinische Anwendungen</p>
          <Link to="/projekte" className="text-gold underline text-sm">→ Zu den Projekten</Link>
        </div>

        {/* Zertifikate */}
        <div className="bg-slateblue p-6 rounded-xl shadow-md w-64 border border-silver 
                        hover:border-gold hover:shadow-[0_0_25px_#e6c770] hover:scale-[1.02] 
                        transition-all duration-300 ease-in-out">
          <h2 className="font-bold text-xl mb-2 text-gold">🎓 Zertifikate</h2>
          <p className="text-gray-200 text-sm mb-2">Nachweise über meine fachlichen Kompetenzen</p>
          <Link to="/zertifikate" className="text-gold underline text-sm">→ Zu den Zertifikaten</Link>
        </div>
      </div>
    </div>
  );
}
